/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a list of numbers to get the full set of descriptive statistics — mean, median, mode, range, variance and standard deviation. Separate values with commas, spaces or new lines.`)
};

const es_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una lista de números para obtener el conjunto completo de estadísticas descriptivas — media, mediana, moda, rango, varianza y desviación estándar. Separa los valores con comas, espacios o saltos de línea.`)
};

const de_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine Zahlenliste ein, um den vollständigen Satz deskriptiver Statistiken zu erhalten — Mittelwert, Median, Modus, Spannweite, Varianz und Standardabweichung. Trenne die Werte mit Kommas, Leerzeichen oder Zeilenumbrüchen.`)
};

const nl_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een lijst met getallen om de volledige set beschrijvende statistieken te krijgen — gemiddelde, mediaan, modus, spreidingsbreedte, variantie en standaardafwijking. Scheid waarden met komma's, spaties of nieuwe regels.`)
};

const fr_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une liste de nombres pour obtenir l'ensemble complet des statistiques descriptives — moyenne, médiane, mode, étendue, variance et écart-type. Séparez les valeurs par des virgules, des espaces ou des retours à la ligne.`)
};

const it_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un elenco di numeri per ottenere l'intero set di statistiche descrittive — media, mediana, moda, intervallo, varianza e deviazione standard. Separa i valori con virgole, spazi o a capo.`)
};

const pt_br2_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de números para obter o conjunto completo de estatísticas descritivas — média, mediana, moda, amplitude, variância e desvio padrão. Separe os valores com vírgulas, espaços ou quebras de linha.`)
};

const pt_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de números para obter o conjunto completo de estatísticas descritivas — média, mediana, moda, amplitude, variância e desvio-padrão. Separe os valores com vírgulas, espaços ou novas linhas.`)
};

const ja_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値のリストを貼り付けると、平均値、中央値、最頻値、範囲、分散、標準偏差といった記述統計の一式が得られます。値はカンマ、スペース、改行のいずれかで区切ってください。`)
};

const zh_st_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一组数字，获得完整的描述性统计结果——平均数、中位数、众数、极差、方差和标准差。数值之间用逗号、空格或换行分隔。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_intro", locale)
	if (locale === "en") return en_st_intro(inputs)
	if (locale === "es") return es_st_intro(inputs)
	if (locale === "de") return de_st_intro(inputs)
	if (locale === "nl") return nl_st_intro(inputs)
	if (locale === "fr") return fr_st_intro(inputs)
	if (locale === "it") return it_st_intro(inputs)
	if (locale === "pt-BR") return pt_br2_st_intro(inputs)
	if (locale === "pt") return pt_st_intro(inputs)
	if (locale === "ja") return ja_st_intro(inputs)
	return zh_st_intro(inputs)
};